import React from 'react';
import { BrowserRouter, Routes, Route,useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import HomePage from './pages/HomePage';
import MnLayerPage from './pages/MnLayerPage';
import PittRigidPage from './pages/PittRigidPage';
import NonlinearTempPage from './pages/NonlinearTempPage';
import NotFoundPage from './pages/NotFoundPage';

const PAGE_TITLES: Record<string, string> = {
  '/': 'Home',
  '/mnlayer': 'MnLayer',
  '/pittrigid': 'PittRigid',
  '/nonlinear-temp': 'Non-Linear Temperature',
};

function TitleManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = PAGE_TITLES[pathname] ?? 'App Hub';
    document.title = `Pitt Pavements | ${page}`;
  }, [pathname]);
  return null;
}

const App: React.FC = () => (
  <BrowserRouter>
    <TitleManager />
    <Routes>
            <Route path="/" element={<HomePage />} />
      <Route path="/mnlayer" element={<MnLayerPage />} />
      <Route path="/pittrigid" element={<PittRigidPage />} />
      <Route path="/nonlineartemp" element={<NonlinearTempPage />} />
      <Route path="*" element={<NotFoundPage />} />  {/* must be last */}
    </Routes>
  </BrowserRouter>
);

export default App;

